import { apiFetch } from '@/lib/api';

export type NotificationCategory = 'escalation' | 'system';

export interface Notification {
  id: number;
  kind: string;
  category: NotificationCategory;
  payload_json: Record<string, unknown>;
  seen_at: string | null;
  created_at: string;
}

export interface NotificationListResponse {
  items: Notification[];
  total: number;
  page: number;
  page_size: number;
}

export interface NotificationListParams {
  category?: NotificationCategory;
  page?: number;
  page_size?: number;
}

export type MarkSeenPayload = { ids: number[] } | { all: true; category?: NotificationCategory };

function buildQuery(params: NotificationListParams): string {
  const usp = new URLSearchParams();
  if (params.category) usp.append('category', params.category);
  if (params.page !== undefined) usp.append('page', String(params.page));
  if (params.page_size !== undefined) usp.append('page_size', String(params.page_size));
  const qs = usp.toString();
  return qs ? `?${qs}` : '';
}

export const notificationService = {
  list(params: NotificationListParams = {}): Promise<NotificationListResponse> {
    return apiFetch<NotificationListResponse>(`/notifications${buildQuery(params)}`);
  },

  unseenCount(): Promise<{ escalation: number; system: number }> {
    return apiFetch<{ escalation: number; system: number }>('/notifications/unseen-count');
  },

  markSeen(payload: MarkSeenPayload): Promise<{ updated: number }> {
    return apiFetch<{ updated: number }>('/notifications/mark-seen', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },
};
